import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import { useLaunchData } from 'contexts/LaunchData';
import _ from 'lodash';
import React from 'react';
import { keywordToFilters } from 'utils/keywordFilters';
const {  useState } = React;
const keywordGroups = {
  factor: '膚質',
  origin: '產地',
  pricing: '價格',
};

const getFiltersKeys = (obj) => {
  return _.filter(Object.keys(obj), (k) => keywordGroups[k] ).length;
}

const KeywordData = ({ CATEGORY_ID }) => {
  const [toggle, setToggle] = useState({});

  return (
    <div className={`rounded-md bg-sorra-gray-50 px-6 pt-6`}>
      {_.map(keywordGroups, (groupName, groupKey) => (
        <div key={groupKey} className="pb-6">
          <h2 className="mb-3 text-lg font-medium text-[#9B9B9B]">{`按${groupName}`}</h2>

          {/* 第一層：所有按鈕橫排 */}
          <div className="mb-3 flex flex-row flex-wrap gap-x-6">
            {_.map(keywordToFilters, (filterValue, filterName) => {
              const hasGroupKey = _.has(filterValue, groupKey);
              const isSingleKey = getFiltersKeys(filterValue) === 1;
              if (!hasGroupKey || !isSingleKey) return null;

              return (
                <div
                  key={filterName}
                  className={`flex cursor-pointer items-center gap-x-2 text-[18px] font-normal ${toggle[filterName] ? 'text-sorra-pink' : ''}`}
                  onClick={() =>
                    setToggle((prev) => {
                      if (prev[filterName]) {
                        return {};
                      }
                      return { [filterName]: true };
                    })
                  }
                >
                  <img
                    src="/svgs/index-partnership-arrow.svg"
                    className={`h-6 w-6 ${toggle[filterName] ? 'rotate-90 transform' : ''}`}
                  />
                 {filterValue?.alias || filterName}
                </div>
              );
            })}
          </div>

          {/* 第二層：展開的內容，固定在下方 */}
          {_.map(keywordToFilters, (filterValue, filterName) => {
            const hasGroupKey = _.has(filterValue, groupKey);
            const isSingleKey = getFiltersKeys(filterValue) === 1;
            if (!hasGroupKey || !isSingleKey) return null;
            if (!toggle[filterName]) return null;

            const filtered = _.filter(
              _.map(keywordToFilters, (v, k) => ({ name: k, value: v })),
              ({ value }) => {
                const hasKey = _.has(value, groupKey);
                const isMulti = getFiltersKeys(value) > 1;
                const currentValue = filterValue[groupKey];
                const subValue = value[groupKey];
                const matches = Array.isArray(currentValue)
                  ? Array.isArray(subValue) && _.isEqual(currentValue, subValue)
                  : Array.isArray(subValue)
                    ? subValue.includes(currentValue)
                    : currentValue === subValue;
                return hasKey && isMulti && matches;
              }
            );

            return (
              <div key={`${filterName}-content`} className="">
                <a
                  href={`/search/${CATEGORY_ID}/${filterName}`}
                  className="text-lg underline"
                >
                  所有{filterValue?.alias || filterName}
                </a>
                {filtered.map((item) => (
                  <span key={item.name}>
                    <span className="mx-2">|</span>
                    <a
                      href={`/search/${CATEGORY_ID}/${encodeURIComponent(item.name)}`}
                      className="text-lg underline"
                    >
                      {item.name}
                    </a>
                  </span>
                ))}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default function Keywords(props) {
  const { categoryTree, notifications } = useLaunchData();
  const [selectedCategory, setSelectedCategory] = useState(null); 
  return (
    <div>
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Keywords',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
        >
          <MaxWidthContainer className="px-4">
            <div
              className={`flex w-[100%] flex-wrap items-center gap-1 py-[16px] lg:py-[32px]`}
            >
              首頁 &gt; 分類彙總
            </div>
          </MaxWidthContainer>
          <MaxWidthContainer className="font-noto-sans px-4  text-sorra-gray-900">
            <h1 className="font-noto-sans pb-10 text-[36px] font-medium">
              分類彙總
            </h1>
            <div className="flex flex-col gap-x-12 gap-y-8 pb-20 ">
              {categoryTree.map((fc, finex) => {
                return (
                  <div key={fc.first_category_id}>
                    <h2 className="mb-4 text-xl font-normal text-[#4A4A4A]">
                      {fc.first_category_name}
                    </h2>
                    <div className="mb-4 flex flex-row flex-wrap gap-x-6">
                      {fc.second_categories.map((sc) => {
                        const isSelected =
                          selectedCategory?.firstCategoryId ===
                            fc.first_category_id &&
                          selectedCategory?.secondCategoryId === sc.id;
                        return (
                          <div
                            key={sc.id}
                            className={`flex cursor-pointer items-center gap-x-1 text-lg ${isSelected ? 'text-sorra-pink' : ''}`}
                            onClick={() => {
                              if (isSelected) {
                                setSelectedCategory(null); 
                              } else {
                                setSelectedCategory({
                                  firstCategoryId: fc.first_category_id,
                                  secondCategoryId: sc.id,
                                });
                              }
                            }}
                          >
                            <img
                              src="/svgs/index-partnership-arrow.svg"
                              className={`h-6 w-6 ${isSelected ? 'rotate-90 transform' : ''}`}
                            />
                            {sc.name}
                          </div>
                        );
                      })}
                    </div>

                    {/* KeywordData 只在這個 first_category 有選中時顯示 */}
                    {selectedCategory?.firstCategoryId ===
                      fc.first_category_id && (
                      <KeywordData
                        CATEGORY_ID={selectedCategory.secondCategoryId}
                      />
                    )}
                    { finex < categoryTree.length - 1 && <div className="border-b border-sorra-gray-100 pb-8"></div>}
                  </div>
                );
              })}
            </div>
          </MaxWidthContainer>

          <Footer />

          <MobileTabBar props={{ highlighted: 'keywords' }} />
        </div>
      </main>
    </div>
  );
}
